export enum CreditCardWorkflowStep {
  SelectNumberOfCards,
  SelectAmountForCard,
  FatZebraIframe,
  PayWayIframe,
  Complete
}
